import { Component, OnInit, ChangeDetectorRef, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-profile-wrapper',
  templateUrl: './profile-wrapper.component.html',
  styleUrls: ['./profile-wrapper.component.css'],
  inputs: ["user"]
})
export class ProfileWrapperComponent implements OnInit {
  user: any = {};
  constructor(private cd: ChangeDetectorRef) {
  }

  ngOnInit() {
  }
  ngOnChanges(changes: SimpleChanges) {
    this.user = changes.user.currentValue;
    this.cd.markForCheck();
  }

}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/profile-update/profile-wrapper/profile-wrapper.component.ts